import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TriagePage } from "@/features/triage/TriagePage";

const search = z.object({
  id: z.string().optional(),
  view: z.enum(["new", "snoozed", "accepted", "declined", "merged", "all"]).optional(),
});

export const Route = createFileRoute("/_app/triage/")({
  validateSearch: search,
  component: () => <TriagePage search={Route.useSearch()} />,
});
